import request from '@/utils/request'
import { isUseAPI } from '@/utils/check'

export function getASCompany() {
  return request({
    url: '/cmm/getASCompany',
    method: 'get'
  })

  // restful api를 사용하지 않을 경우
  /*
  return new Promise(function(resolve, reject) {
    resolve(siteList);
  });
  */
}

export function getComCode(codename) {
  return request({
    url: '/cmm/getComCode/codename/' + codename,
    method: 'get'
  })
}

export function getComCodeList() {
  return request({
    url: '/cmm/getComCodeAllList',
    method: 'get'
  })
}

export function getMaterialCodeList(params) {
  return request({
    url: '/cmm/getMaterialCodeList',
    method: 'POST',
    data: params
  })
}

export function getSiteModelList(params) {
  return request({
    url: '/cmm/site/getSiteModelList',
    method: 'POST',
    data: params
  })
}
